import styled from 'styled-components';
import { Divider } from 'antd';
import { TableLabel } from '../../style';
import { DataValue, PrimaryButtonComponent, SectionLabel } from "../../../../../../CommonComponents/commonStyles";

export const CustomSectionLabel = styled(SectionLabel)`
  font-size: ${props => props.theme.fontSize.secondary} !important;
  @media only screen and (min-width: 992px) {
    font-size: ${props => props.theme.fontSize.primary} !important;
  }
`

export const ModalHeaderSubText = styled(TableLabel)`
  text-align: center;
  margin-top: 10px;
  @media (min-width: 992px) {
    margin-top: 15px;
  }
`

export const ScheduleLabel = styled(DataValue)`
  margin-top: 17px;
  margin-bottom: 5px;
`

export const CustomPrimaryButtonWrap = styled.div`
  margin-bottom: 10px;
`

export const TopDivider = styled(Divider)`
border: solid 1px ${props => props.theme.colors.border};
margin-top: 10px;
margin-bottom: 10px;
@media (min-width: 992px) {
  margin-top: 20px;
  margin-bottom: 15px;
}
`

export const ButtonContainer = styled.div`
  ${props => props.pad ? "padding-top: 30px;" : ""}
  text-align: center;
  width: 150px;
`

export const AlertAddress = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.thead};
  line-height: ${props => props.theme.lineHeight.secondary};
  @media (min-width:992px){
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
`;